import './list';

import './association.service.js';



// WEBPACK FOOTER //
// ./components/collector/associations/index.js